import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronDown = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M18 9L12 15L6 9'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M12 15.75C12.1989 15.75 12.3896 15.6709 12.5303 15.5303L18.5303 9.53027L18.582 9.47363C18.8223 9.17905 18.8049 8.74433 18.5303 8.46973C18.2557 8.19512 17.821 8.17766 17.5264 8.41797L17.4697 8.46973L12 13.9395L6.53028 8.46973C6.23738 8.17683 5.76262 8.17683 5.46973 8.46973C5.17684 8.76262 5.17684 9.23738 5.46973 9.53027L11.4697 15.5303L11.584 15.624C11.7063 15.7056 11.8509 15.75 12 15.75Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
